module.exports = __webpack_public_path__ + "315fe5e22782b1c90da2f17263472d11.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/john-feminella.jpg
// module id = 667
// module chunks = 0